// extracted by mini-css-extract-plugin
export default {"links":"style_links__oS9pN","fanzinfo":"style_fanzinfo__6DmT6"};